import events from "../framework/src/events/EventsObservable";
import {cylinder_pos, icons, last_symbol, symbols} from "./ps_config";
import {
    states,
    server_config,
    behavior_config,
    ico_he,
    reels_pos,
    rotated,
    round_running,
    set_rotated,
    picture_convert,
    server_result,
    alldone,
    in_free_spins,
    set_round_running,
    fps,
    forcestopnow,
    reels_lenghts, set_forcestopnow
} from "../framework/src/engine/madnes/madnes_variables";
import {end_standing_symbols, fadein_reel_bonus_from, fadeout_all_reel_bonus, fadeout_reel_bonus} from "./ps_anims";
import {madnes_add_to_render, madnes_rem_from_render} from "../framework/src/engine/madnes/madnes_render";
import {
    madnes_audio_fade_out,
    madnes_audio_is_playing,
    madnes_audio_loop,
    madnes_audio_play
} from "../framework/src/engine/madnes/madnes_audio";
import {print_reels} from "./ps_core_printer";
import {
    madnes_set_texture,
    madnes_sprite_get_frame_name,
    madnes_sprite_set_frame_name
} from "../framework/src/engine/madnes/madnes_object";
import {
    madnes_forcestopnow, madnes_is_in_autostart, madnes_reels_start, madnes_reels_stop,
    madnes_spin_end,
    madnes_spin_start
} from "../framework/src/engine/madnes/madnes";
import {
    madnes_anim_add,
    madnes_anim_add_oncomplete_once,
    madnes_anim_play
} from "../framework/src/engine/madnes/madnes_anims";
import {result_control} from "./ps_core_res_ctrl";
import {STATES} from "../framework/src/states/states";

// Kontrola probihajici rotace valcu
export const stopposin = [];
var startposin = new Array();
var stopposin_round = new Array();
var stop_anim_played = new Array();

export const stopposin_old = [];
var stoppostime_br = new Array();
var stoppostime = new Array();

var stoppos_swing = new Array();

var scatters = 0;
var saloons = 0;
var all_set_for_stop = 0;

var scatters_runned = false;

var faded_in_anim = [];

var rotate_start_time = 0;
var rotate_start_pos = [];
var rotate_start_in_accel = 0;
var rotate_start_swing = 0;
var can_stop = 0;
var rotate_control_start_time = 0;
var rotate_control_swing_end = 0;

var frame_blur = 1;
var frame_sharp = 0;

var scatter_reels_count = 0;
var bonus_reels_count = 0;

var autospin_force = false;
var autospin_force_enabled = false;

var audioForceStopPlayed = false;
var audioForceWildPlayed = false;
var audioForceScatterPlayed = false;
var audioForceMysteryPlayed = false;



function get_current_time()
{
    return window.performance ? window.performance.now() : new Date().getTime();
}

export function rotate_run(/*autostarted*/)
{
    if(round_running) //waiting for end round
    {
        return;
    }

    end_standing_symbols();
    rotate_start();
}

var spin_start_time = null;

export function rotate_start()
{
    autospin_force_enabled = false;

    if(!rotated)
    {
        madnes_spin_start();

        scatter_reels_count = 0;
        bonus_reels_count = 0;

        // madnes_show_stop(); //#
        // madnes_win_anim_reset(); //#

        for(var i = 0; i < server_config.logic.reels.length; i++)
        {
            while(stopposin[i] > server_config.logic.reels[i].length)
            {
                stopposin[i] = stopposin[i] * 1 - server_config.logic.reels[i].length;
                stopposin_old[i] = stopposin[i];
                reels_pos[i] = stopposin[i] * ico_he;
            }
        }

        set_rotated(true); //rotated = 1;

        startposin = JSON.parse(JSON.stringify(stopposin));

        for(var i = 0; i < cylinder_pos.length; i++)
        {
            symbols[i] = 0;
            last_symbol[i] = -1;
            rotate_start_pos[i] = reels_pos[i];
        }

        can_stop = 0;

        rotate_start_time = get_current_time();

        rotate_control_start_time = 0;
        rotate_start_in_accel = 0;
        rotate_start_swing = 0;
        set_forcestopnow(0); //forcestopnow = 0; //#
        scatters_runned = false;

        madnes_audio_play("pre_reels");

        madnes_reels_start();
        madnes_add_to_render(rotate_start);
    }
    else
    {
        var time = get_current_time() - rotate_start_time;

        if(
            rotate_start_swing < behavior_config.reel.acceleration.swingCount &&
            //behavior_config.reel.acceleration.accelerationHeight &&
            time < behavior_config.reel.acceleration.moveBackTime * 1000 &&
            rotate_start_in_accel == 0
        )
        {
            // back
            var time_perc = ( ( 100 / ( behavior_config.reel.acceleration.moveBackTime * 1000 ) ) * time ) / 100;
            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he * time_perc );
            }
        }
        else if(
            rotate_start_swing < behavior_config.reel.acceleration.swingCount &&
            //behavior_config.reel.acceleration.accelerationHeight &&
            time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 &&
            rotate_start_in_accel == 0
        )
        {
            // keep
            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he * 1 );
            }
        }
        else if(
            rotate_start_swing < behavior_config.reel.acceleration.swingCount &&

            //time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 + behavior_config.reel.acceleration.moveTime * 1000 &&
            time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 + behavior_config.reel.acceleration.moveBackTime * 1000 &&
            rotate_start_in_accel == 0
        )
        {
            // acc

            var time_perc =
                1 - (
                    (
                        (
                            100 / (
                                //behavior_config.reel.acceleration.moveTime * 1000
                                behavior_config.reel.acceleration.moveBackTime * 1000
                            )
                        ) * (
                            time - (
                                behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000
                            )
                        )
                    ) / 100
                );

            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he * time_perc );
            }

        }
        else if(
            rotate_start_in_accel == 0
        )
        {
            // rotate accel start or repeat

            madnes_audio_loop("REEL_BG");

            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i];
            }

            rotate_start_time = get_current_time();

            if(++rotate_start_swing >= behavior_config.reel.acceleration.swingCount)
            {

                /*for(var i = 0; i < cylinder_pos.length; i++)
                {
                    if(behavior_config.reel.spin.motionBlur == 1)
                    {
                        madnes_anim_play("reels_bufer_" + i + "_S0", "blur");
                        madnes_anim_play("reels_bufer_" + i + "_S1", "blur");
                        madnes_anim_play("reels_bufer_" + i + "_S2", "blur");

                        for(var j = 0; j < reels_lenghts[i]; j++)
                        {
                            //madnes_anim_play("reels_bufer_" + i + "_" + j, "blur");
                        }

                    }
                }*/

                rotate_start_in_accel = 1;

                rotate_control_start_time = get_current_time();
            }
        }
        else if(
            rotate_start_in_accel == 1
        )
        {
            // accel start
            var start_speed = behavior_config.reel.acceleration.accelerationHeight / behavior_config.reel.acceleration.moveBackTime;

            if(!isFinite(start_speed) || isNaN(start_speed))
            {
                start_speed = 0;
            }

            var end_speed = behavior_config.reel.spin.commonSpeed;
            // if(in_free_spins)
            // {
            //     end_speed = behavior_config.reel.spin.freeSpinSpeed;
            // }

            var end_time = behavior_config.reel.spin.timeToReachFullSpeed * 1000;

            var perc = 0;
            var speed = 0;
            var pos = 0;
            var sampling = 10;

            for(var i = 0; i <= time; i = i * 1 + sampling * 1)
            {
                perc = 100 / end_time * i;
                if(!isFinite(perc) || isNaN(perc))
                {
                    perc = 0;
                }
                speed = ( ( end_speed - start_speed ) * ( perc / 100 ) ) + start_speed * 1;
                pos = pos * 1 + ( speed / ( 1000 / ( sampling * 1 ) ) );
            }

            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] + pos * ico_he;
            }

            if(
                !(
                    time < behavior_config.reel.spin.timeToReachFullSpeed * 1000
                )
            )
            {
                pos = 0;

                for(var i = 0; i <= ( behavior_config.reel.spin.timeToReachFullSpeed * 1000 ); i = i * 1 + sampling * 1)
                {
                    perc = 100 / end_time * i;
                    if(!isFinite(perc) || isNaN(perc))
                    {
                        perc = 0;
                    }
                    speed = ( ( end_speed - start_speed ) * ( perc / 100 ) ) + start_speed * 1;
                    pos = pos * 1 + ( speed / ( 1000 / ( sampling * 1 ) ) );
                }

                rotate_control_swing_end = pos;

                for(var i = 0; i < cylinder_pos.length; i++)
                {
                    for(var j in server_config.logic.reels[i])
                    {
                        madnes_set_texture("reels_bufer_" + i + "_" + j, "symbols_atlas");
                        madnes_sprite_set_frame_name("reels_bufer_" + i + "_" + j, picture_convert[server_config.logic.reels[i][j]] + "_blur");
                    }
                }

                for(var i = 0; i < cylinder_pos.length; i++)
                {
                    for(var j = 0; j < 3; j++) {
                        madnes_set_texture("reels_bufer_" + i + "_S" + j, "symbols_atlas");
                        madnes_sprite_set_frame_name("reels_bufer_" + i + "_S" + j, get_orig_texture_name(madnes_sprite_get_frame_name("reels_bufer_" + i + "_S" + j)) + "_blur");
                    }
                }

                madnes_rem_from_render(rotate_start);
                madnes_add_to_render(rotate_control);
            }
        }

        print_reels();
    }
}

export function reset_faded_in_anim() {
    for(var i = 0; i < cylinder_pos.length; i++) {
        faded_in_anim[i] = false;
    }
}

function rotate_control()
{
    var time = get_current_time();

    if(rotated || all_set_for_stop == 0)
    {
        // Toci se a zatim se neceka ukonceni

        for(var i = 0; i < cylinder_pos.length; i++)
        {
            if(server_result != null)
            {
                stopposin[i] = -1;
                stopposin_round[i] = 0;
                stop_anim_played[i] = false;
                stoppostime_br[i] = -1;
                stoppos_swing[i] = 0;
                stoppostime[i] = -1;
                can_stop = 1;
            }

            alldone[i] = 0;

            var cs = behavior_config.reel.spin.commonSpeed;
            // if(in_free_spins)
            // {
            //     cs = behavior_config.reel.spin.freeSpinSpeed;
            // }

            reels_pos[i] =
                (
                    rotate_start_pos[i] +
                    (
                        (
                            (
                                (
                                    time - rotate_control_start_time - (
                                        behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                    )
                                ) / 1000
                            ) * cs
                        ) + rotate_control_swing_end
                    ) * ico_he
                );
            var symbdiff =
                (
                    (
                        (
                            (
                                time - rotate_control_start_time - (
                                    behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                )
                            ) / 1000
                        ) * cs
                    ) + rotate_control_swing_end
                );
        }

        scatters = 0;
        saloons = 0;

    }
    else
    {
        // Je na case ukoncit toceni na spravnych pozicich

        //server_result.result.gameSpecifics.scatterSearch.index = 1;
        //server_result.result.gameSpecifics.scatterSearch.type = "scatter";

        for(var i = 0; i < cylinder_pos.length; i++)
        {
            if(stopposin[i] == -1)
            {
                /*for(var spos = 0; spos <= 2; spos++) {
                    (function(ii, pos) {
                        setTimeout(function() {
                            var symbName = "reels_bufer_" + ii + "_S" + ( 2 - pos );
                            var symbTexture = madnes_get_texture(symbName).replace("_blur", "").replace("_touchdown", "");

                            //madnes_set_texture(symbName, symbTexture + "_touchdown");
                            madnes_anim_add(symbName, "land", icons[symbTexture + "_touchdown"]["land"]);
                            //madnes_anim_play(symbName, "land", 30);
                        }, 1000/fps * (pos * 10));
                    }(i, spos));

                    //remove_anim_oncomplete(symbName, "land");
                }*/

                // Nejsou nastaveny pozice pro ukonceni -> nastavuji
                if(madnes_forcestopnow())
                {
                    var cs = behavior_config.reel.spin.commonSpeed;
                    if(in_free_spins)
                    {
                        cs = behavior_config.reel.spin.freeSpinSpeed;
                    }

                    var strns = cs * behavior_config.reel.spin.timeToReachNullSpeed;

                    stopposin[i] = Math.round(reels_pos[i] / ico_he) + ( 2 + /* 3 + Math.floor( cs / 4 ) +*/ Math.ceil( strns ) );

                    if(i > 0)
                    {
                        stopposin[i] = ( reels_lenghts[0] - startposin[0] ) + ( ( stopposin_round[0] - 1 ) * reels_lenghts[0] ) + stopposin[0] + startposin[i];
                    }

                }
                else
                {
                    var del = 1;
                    if(typeof behavior_config.reel.spin.delayBetweenReelStops != "undefined")
                    {
                        del = behavior_config.reel.spin.delayBetweenReelStops;
                    }
                    var cs = behavior_config.reel.spin.commonSpeed;
                    if(in_free_spins)
                    {
                        cs = behavior_config.reel.spin.freeSpinSpeed;
                    }

                    var strns = cs * behavior_config.reel.spin.timeToReachNullSpeed;

                    stopposin[i] = Math.round(reels_pos[i] / ico_he) + /*(i * del) + */( 2 + /* 3 + Math.floor( cs / 4 ) +*/ Math.ceil( strns ) );

                    if(i > 0)
                    {
                        //stopposin[i] = stopposin[i - 1] + del;
                        stopposin[i] = ( reels_lenghts[0] - startposin[0] ) + ( ( stopposin_round[0] - 1 ) * reels_lenghts[0] ) + stopposin[0] + startposin[i] + ( i * del );

//						if(stopposin[i - 1] + del > stopposin[i]) {
//							//stopposin[i] += del;
//						}

                    }
                }

                if(server_result['result']['gameSpecifics'])
                {
                    var scatterSearch = server_result['result']['gameSpecifics']['scatterSearch'];
                    var scatterSearchIdx = scatterSearch['index'] * 1 + 1;
                    var scatterSearchType = scatterSearch['type'];
                    var scatterDuration = server_config['behavior']['reel']['spin']['scatterDuration'];
                    var scatterDelay = server_config['behavior']['reel']['spin']['scatterDelay'];

                    if(scatterSearch['index'] > -1) {

                        if(scatterSearchType == "scatter" || scatterSearchType == "mystery") {
                            var fromIndex = scatterSearchIdx;

                            if(i >= fromIndex) {

                                if(typeof scatterDuration !== "undefined") {

                                    var add = cylinder_pos.length - (cylinder_pos.length - i) - fromIndex + 1;

                                    if(!add) {
                                        add = 1;
                                    }

                                    stopposin[i] += (scatterDuration * 1 * (i - fromIndex + add) ) + scatterDelay;

                                } else {
                                    stopposin[i] += 20 * fromIndex;
                                }
                            }
                        }
                    }
                }

                while(stopposin[i] <= 0)
                {
                    stopposin[i] = ( reels_lenghts[i] * 1 ) - stopposin[i];
                }

                stopposin_old[i] = stopposin[i];
            }

            var cs = behavior_config.reel.spin.commonSpeed;
            if(in_free_spins)
            {
                cs = behavior_config.reel.spin.freeSpinSpeed;
            }
            var end_break_reel_dist = madnes_get_end_dist();

            //var ttrfs = behavior_config.reel.spin.timeToReachFullSpeed;
            var ttrns = behavior_config.reel.spin.timeToReachNullSpeed;

            if(madnes_forcestopnow())
            {
                end_break_reel_dist = 0;
                ttrns = 0.01;
            }

            var symbdiff =
                (
                    (
                        (
                            (
                                time - rotate_control_start_time - (
                                    behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                )
                            ) / 1000
                        ) * cs
                    ) + rotate_control_swing_end
                );

            if(
                !forcestopnow &&
                (
                    (stopposin[i]) - end_break_reel_dist + 0 - ( rotate_start_pos[i] / ico_he ) >= symbdiff &&
                    (stopposin[i]) - end_break_reel_dist + 0 - ( rotate_start_pos[i] / ico_he ) >= 0
                )
            )
            {
                reels_pos[i] =
                    (
                        rotate_start_pos[i] +
                        (
                            (
                                (
                                    (
                                        time - rotate_control_start_time - (
                                            behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                        )
                                    ) / 1000
                                ) * cs
                            ) + rotate_control_swing_end
                        ) * ico_he
                    );

            }
            else if(stoppostime[i] == -1)
            {
                if(stoppostime_br[i] == -1)
                {
                    stoppostime_br[i] = time;
                }

                var dif_time = time - stoppostime_br[i];

                var cur_end = 0;

                if(dif_time <= ttrns * 1000)
                {
                    dif_time = madnes_get_dist_break(dif_time);

                    reels_pos[i] =
                        (
                            ( ( ( stopposin[i] + 0 ) - ( end_break_reel_dist * 1 ) + ( dif_time * 1 ) ) ) * ico_he

                        );
                }
                else
                {
                    cur_end = 1;
                }

                if(cur_end == 1)
                {
                    stoppostime[i] = time;

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 ) * ico_he
                        );

                    if(alldone[i] == 0)
                    {

                        for(var spos = 0; spos <= 2; spos++) {
                            var symbName = "reels_bufer_" + i + "_S" + ( 2 - spos );
                            var symbTexture = get_orig_texture_name(madnes_sprite_get_frame_name(symbName));
//							var symbTexture = madnes_get_cstm_val(symbName);

                            (function(symbName, symbTexture) {

                                madnes_anim_play(symbName, "land", 24);

                                madnes_anim_add_oncomplete_once(symbName, function() {
                                    madnes_set_texture(symbName, "symbols_atlas");
                                    madnes_sprite_set_frame_name(symbName, symbTexture);
                                });

                            }(symbName, symbTexture));
                        }


                        for(var j in server_config.logic.reels[i])
                        {
                            madnes_sprite_set_frame_name("reels_bufer_" + i + "_" + j, picture_convert[server_config.logic.reels[i][j]]);
                        }

                        sound_reel_stop(server_result.result.reelMatrix[0][i], i);
                    }
                }
            }
            else
            {
                var end_time = stoppostime[i];
                var dif_time = time - end_time;

                var bh = behavior_config.reel.brake.brakeHeight;
                var kt = behavior_config.reel.brake.keepTime;
                var mbt = behavior_config.reel.brake.moveBackTime;
                var mt = behavior_config.reel.brake.moveTime;
                //var mt = behavior_config.reel.brake.moveBackTime;


                cs = behavior_config.reel.spin.commonSpeed;
                if(in_free_spins)
                {
                    cs = behavior_config.reel.spin.freeSpinSpeed;
                }

                //cs - rychlost
                //bh - vyska
                //mt = bh / cs;

                var swc = behavior_config.reel.brake.swingCount;

                if(dif_time < mt * 1000)
                {
                    var add_pos = ( ( (100 / ( mt * 1000 ) ) * dif_time ) / 100 ) * bh;

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 + add_pos ) * ico_he
                        );
                }
                else if(dif_time < mt * 1000 + kt * 1000)
                {
                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 + bh ) * ico_he
                        );
                }
                else if(dif_time < mt * 1000 + kt * 1000 + mbt * 1000)
                {
                    if(i === 3 && !in_free_spins && !madnes_is_in_autostart())
                    {
                        states.setState(STATES.FORCESPIN);
                        //events.dispatch(GAME_EVENTS.GAME_SET_FORCESPIN);
                        // autospin_force_enabled = true;
                        //madnes_show_spin(); //#
                    }

                    var time2 = dif_time - ( mt * 1000 + kt * 1000 );

                    var add_pos = bh - ( ( ( (100 / ( mbt * 1000 ) ) * time2 ) / 100 ) * bh );

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 + add_pos ) * ico_he
                        );

                }
                else
                {
                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0  ) * ico_he
                        );

                    if(++stoppos_swing[i] < swc)
                    {
                        stoppostime[i] = time;
                    }
                    else
                    {
                        if(alldone[i] * 1 == 0)
                        {
                            if(server_result['result']['gameSpecifics'])
                            {
                                var searchIdx = server_result['result']['gameSpecifics']['scatterSearch']['index'] + 1;

                                if(i + 1 == searchIdx) {
                                    fadein_reel_bonus_from(i + 1, server_result['result']['gameSpecifics']['scatterSearch']['type']);
                                    madnes_audio_play("REEL_TEAS");
                                }
                            }

                            if(!is_symbol_in_reel(server_result['result'].reelMatrix[0][i], "symbol_Scatter") && !in_free_spins && !forcestopnow) {
                                //console.log(i,server_result['result'].reelMatrix[0][i]);
                                fadeout_reel_bonus(i + 1, 'scatter');
                            }

                            if(!is_symbol_in_reel(server_result.result.reelMatrix[0][i], "symbol_Mystery") && !forcestopnow) {
                                fadeout_reel_bonus(i + 1, 'mystery');
                            }
                        }

                        if(i === cylinder_pos.length - 1)
                        {
                            madnes_audio_fade_out("REEL_BG", 100);
                        }

                        alldone[i] = 1;
                    }
                }
            }
        }

        if(alldone.indexOf(0) == -1)
        {
            audioForceStopPlayed = false;
            audioForceWildPlayed = false;
            audioForceScatterPlayed = false;
            audioForceMysteryPlayed = false;

            if(madnes_audio_is_playing("REEL_TEAS")) {
                madnes_audio_fade_out("REEL_TEAS", 300);
            }

            for(var i = 0; i < cylinder_pos.length; i++) {

                if(is_symbol_in_reel(server_result['result']['reelMatrix'][0][i], "symbol_Scatter")) {
                    scatter_reels_count++;
                }

                if(is_symbol_in_reel(server_result['result']['reelMatrix'][0][i], "symbol_Mystery")) {
                    bonus_reels_count++;
                }
            }

            if(server_result.result.gameSpecifics)
            {
                if(
                    server_result.result.gameSpecifics.scatterSearch.index > -1 &&
                    server_result.result.gameSpecifics.scatterSearch.type == 'scatter' &&
                    scatter_reels_count < 3 && !in_free_spins
                ) {
                    fadeout_all_reel_bonus("scatter");
                }

                if(
                    server_result.result.gameSpecifics.scatterSearch.index > -1 &&
                    server_result.result.gameSpecifics.scatterSearch.type == 'mystery' &&
                    bonus_reels_count < 3
                ) {
                    fadeout_all_reel_bonus("mystery");
                }
            }

            setTimeout(() => {
                madnes_reels_stop();
                result_control();
            }, 300);
            madnes_spin_end();
            madnes_rem_from_render(rotate_control);
        }

    }

    print_reels();
}

function is_symbol_in_reel(reel, symbol) {

    for(var i in reel) {
        if(picture_convert[reel[i]] == symbol) {
            return true;
        }
    }

    return false;
}

/*function remove_anim_oncomplete(name, animname) {
	madnes_anim_add_oncomplete(name, function() {
		madnes_anim_remove(name, animname);
	});
}*/

var madnes_get_end_dist_tmp = -1;
var madnes_get_end_dist_tmp_free = -1;
function madnes_get_end_dist()
{
    if(in_free_spins)
    {
        if(madnes_get_end_dist_tmp_free != -1)
        {
            return madnes_get_end_dist_tmp_free;
        }
    }
    else
    {
        if(madnes_get_end_dist_tmp != -1)
        {
            return madnes_get_end_dist_tmp;
        }
    }

    var total_time = behavior_config.reel.spin.timeToReachNullSpeed * 1000;
    var distance = madnes_get_dist_break(total_time);

    if(in_free_spins)
    {
        madnes_get_end_dist_tmp_free = distance;
    }
    else
    {
        madnes_get_end_dist_tmp = distance;
    }

    return distance;
}

function madnes_get_dist_break(time)
{
    var sampling = 10;

    //var end_speed = behavior_config.reel.brake.brakeHeight / behavior_config.reel.brake.moveTime;
    var end_speed = behavior_config.reel.brake.brakeHeight / behavior_config.reel.brake.moveBackTime;

    if(!isFinite(end_speed) || isNaN(end_speed))
    {
        end_speed = 0;
    }

    var start_speed = behavior_config.reel.spin.commonSpeed;
    if(in_free_spins)
    {
        start_speed = behavior_config.reel.spin.freeSpinSpeed;
    }

    end_speed = start_speed;

    var total_time = behavior_config.reel.spin.timeToReachNullSpeed * 1000;

    var distance = 0;

    for(var i = 0; i <= time; i += sampling)
    {
        var proc = 100 - ( ( 100 / total_time ) * i );
        var speed = ( ( start_speed - end_speed ) * ( proc / 100 ) ) + end_speed;
        distance = ( distance * 1 ) + ( speed * sampling ) ;
    }
    distance = distance / 1000;
    return distance;
}

// Pozadavek na dotoceni valce
var rotate_stop_loading = 0;
export function rotate_stop() {
    if(rotated != 0 && rotate_stop_loading == 0)
    {
        for(var i = 0; i < cylinder_pos.length; i++)
        {
            stopposin_old[i] = -1;
        }
        all_set_for_stop = 0;
        rotate_stop_loading = 1;

        var cached = 0;
//		var loaded_texture_cache = {};

        for(var i in server_result.result.reelMatrix[0])
        {
            for(var j in server_result.result.reelMatrix[0][i])
            {
                var resSymbolName = "reels_bufer_" + i + "_S" + ( 2 - j );
                var resSymbolTexture = picture_convert[server_result.result.reelMatrix[0][i][j]];

//				if(!(resSymbolTexture in loaded_texture_cache))
//				{
//					(function(resSymbolName, resSymbolTexture)
//					{
//						cached++;
//
//						setTimeout(function() {
//							madnes_set_texture(resSymbolName, resSymbolTexture + "_touchdown_json");
//							madnes_anim_add(resSymbolName, "land", icons[resSymbolTexture]["touchdown"]);
//
//						}, (1000 / ( fps ) | 0 ) * cached);
//
//					} (resSymbolName, resSymbolTexture));
//
//					loaded_texture_cache[resSymbolTexture] = true;
//				}
//				else
//				{
                madnes_set_texture(resSymbolName, resSymbolTexture + "_touchdown_json");
                madnes_anim_add(resSymbolName, "land", icons[resSymbolTexture]["touchdown"]);
//				}

//				madnes_set_cstm_val(resSymbolName, resSymbolTexture);
            }
        }

        setTimeout(function()
        {
            all_set_for_stop = 1;
            rotate_stop_loading = 0;
            set_rotated(0);
        }, (1000 / ( fps ) | 0 ) * cached + 5);
    }
}

function rotate_release()
{
    if(autospin_force_enabled)
    {
        autospin_force = true;
    }

    autospin_force_enabled = false;
}

function forcestop_press()
{
    autospin_force = false;
}

function sound_reel_stop(reel, i)
{
    var num = (i * 1 + 1);

    if(forcestopnow) {

        if(is_symbol_in_reel(reel, "symbol_Wild")) {

            if(!audioForceWildPlayed) {
                madnes_audio_play("wild_snd_3");
            }
            audioForceWildPlayed = true;
            return;
        }

        if(is_symbol_in_reel(reel, "symbol_Scatter")) {

            if(!audioForceScatterPlayed) {
                madnes_audio_play("bonus_snd_3");
            }
            audioForceScatterPlayed = true;
            return;
        }

        if(is_symbol_in_reel(reel, "symbol_Mystery")) {

            if(!audioForceMysteryPlayed) {
                madnes_audio_play("mystery_snd_3");
            }
            audioForceMysteryPlayed = true;
            return;
        }

        if(!audioForceStopPlayed) {
            madnes_audio_play("reel_stop_3");
            audioForceStopPlayed = true;
        }
        return;
    }

    if(is_symbol_in_reel(reel, "symbol_Wild"))
    {
        madnes_audio_play("wild_snd_" + num);
    }
    else if (is_symbol_in_reel(reel, "symbol_Scatter"))
    {
        madnes_audio_play("bonus_snd_" + num);
    }
    else if (is_symbol_in_reel(reel, "symbol_Mystery"))
    {
        madnes_audio_play("mystery_snd_" + num);
    }
    else
    {
        madnes_audio_play("reel_stop_" + num);
    }
}

export function get_orig_texture_name(textureName) {
    textureName = textureName.replace("_standing", "")
        .replace("_touchdown", "")
        .replace("_json", "")
        .replace("_sheet", "")
        .replace("_blur", "")
        .replace("-", "_")
        .replace(/_\d+/g, "");

    if(textureName === "symbol_Princes") {
        textureName = "symbol_Princess";
    }

    if(textureName === "symbol_Clown") {
        textureName = "symbol_Scatter";
    }

    if(textureName === "symbol_Witch") {
        textureName = "symbol_Mystery";
    }

    return textureName;
}